// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2eNs7","buttons":"SendReceipts_buttons__3vZp_","email":"SendReceipts_email__1TLhN","bookApptTitle":"SendReceipts_bookApptTitle__3m7nx"};